angular.module('rjmNg.directives').directive "invite", [
  "$routeParams",
  "Invites",
  "Session",
  "Clients",
  "$timeout",
  "notification"
  ($routeParams, Invites, Session, Clients, $timeout, notification) ->
    restrict: "E"
    templateUrl: "directive.invite.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$window"
      "app"
      (
       $window
       app
      ) ->
        if not app.isSignInAvailable()
          $window.location = "/v2/session/create"

        errorMessages=
          redeemInvite: "We ran into a problem creating your account.  Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."
          createSession: "We ran into a problem logging into your account."

        _pollStatus = (clientId) ->
          Clients.get(clientId, false)
          .then (client) ->
            if client.properties.is_provisioned
              $window.location = '/'
              view.loading = false
            else
              $timeout ->
                _pollStatus clientId
              , 5000

        view = @

        view.loading = true
        view.userEmail = null

        view.inviteData =
          password: null
          first_name: null
          last_name: null
          company: null
          role: null
          existing_user: false

        Invites.getRedemption($routeParams.token)
        .then (response) ->
          view.inviteData.first_name = response.properties.first_name
          view.inviteData.last_name = response.properties.last_name
          view.inviteData.company = response.properties.company
          view.inviteData.role = response.properties.role
          view.inviteData.existing_user = response.existing_user
          view.inviteData.force_create = response.properties.force_create is "1"

          view.userEmail = response.email
          view.passwordSet = view.inviteData.existing_user and not view.inviteData.force_create

          if response.invite_client?.name?
            view.inviteData.company = response.invite_client.name

          # Its a new client signup with a new user - we only need the password since
          # the user details are already filled out on the signup form
          view.onlySettingPassword = not response.client_id?

          # its a new user that is joining an existing client
          view.needUserDetails = view.inviteData.force_create or not view.inviteData.existing_user and response.client_id?
          view.loading = false

        .catch (error) ->
          redemptionErrorTitle = null
          redemptionErrorMessage = "We were unable to verify this password reset token.
            Please try signing up again."

          if error.status is 403

            redemptionErrorTitle = "Reset token expired."

            redemptionErrorMessage = "This password reset token is no longer valid. Please try signing up again."

          notification.error(redemptionErrorTitle, redemptionErrorMessage, "invite-notifications", { dismissable: false, bindHtml: false })
          view.loading = false

        view.password =
          new: null
          confirm: null

        view.acceptInvite = ->
          view.inviteData.password = view.password.confirm
          view.loading = true

          Invites.redeemInvite($routeParams.token, view.inviteData)
          .then (response) ->
            notification.clear('invite-notifications')
            if view.inviteData.existing_user and not view.inviteData.force_create
              $window.location = "/v2/session/create"
            else
              Session.create(view.userEmail, view.inviteData.password, false)
                .then (response) ->
                  _pollStatus(response.clientId)
                .catch (data) ->
                  view.loading = false
                  if ( data != 'canceled')
                    notification.error("Session create failed.", errorMessages.createSession, "invite-notifications", { dismissable: false, bindHtml: true })
          .catch ({data}) ->
              view.loading = false
              notification.error("Redeem invite failed.", errorMessages.redeemInvite, "invite-notifications", { dismissable: false, bindHtml: true })

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "invite", scope.view.loading, "Setting up your account"
]
